// extracted by mini-css-extract-plugin
export var paginationContainer = "_86-0";